"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParallaxOffsets = getParallaxOffsets;

var _index = require("../utils/index");

/**
 * Gets the parallax X and Y offsets to be applied to an element
 * based upon the percent the element has moved in the viewport
 * and the min/max offsets
 * @returns {Object}
 */
function getParallaxOffsets(offsets, percentMoved) {
  var y0 = offsets.y0,
      y1 = offsets.y1,
      x0 = offsets.x0,
      x1 = offsets.x1;
  var yUnit = y1.unit;
  var xUnit = x1.unit;
  var x = (0, _index.scaleBetween)(percentMoved, x0.value, x1.value, 0, 100);
  var y = (0, _index.scaleBetween)(percentMoved, y0.value, y1.value, 0, 100);
  return {
    x: {
      value: x,
      unit: xUnit
    },
    y: {
      value: y,
      unit: yUnit
    }
  };
}